import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Input } from '@components/core-ui/form-elements/Input';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { useAPI } from '@providers/useAPI';
import { AdminService } from 'app/API';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { Content } from './styles/Content';
import { TProps } from './types';

export const AdminAddNewAttorneysAccessModal = ({ onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const [email, setEmail] = useState('');
  const [recordingSessionId, setRecordingSessionId] = useState('');

  const createNewAttorneysAccess = async () => {
    call(AdminService.addNewAttorneyAccess({ email, recordingSessionId }), {
      onError: (message) => toast.error(message),
      onSuccess: () => {
        toast.success('Access created!');
        onSuccess();
        onCancel();
      },
    });
  };

  return (
    <ModalWrapper width="400px">
      <ModalTitle>Add new attorneys access</ModalTitle>
      <Content className="flex flex-col items-center justify-center">
        <Input
          label="Attorneys Email"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setEmail(event.target.value)}
          value={email}
        />
        <Input
          className="mt-4"
          label="Recording Session Id"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setRecordingSessionId(event.target.value)}
          value={recordingSessionId}
        />

        <div className="buttonWrapper w-full max-w-[70%] self-end">
          <OutlinedButton onClick={() => onCancel()}>Cancel</OutlinedButton>
          <Button onClick={createNewAttorneysAccess} disabled={!email || !recordingSessionId}>
            Create
          </Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
